import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useJournal } from "./JournalContext";
import { useJournalName } from "./JournalNameContext";
import { downloadJournalJson, downloadJournalMarkdown } from "./exportJournal";

const ExportJournalButtons = ({ variant = "menu" }) => {
  const { t } = useTranslation();
  const { journalName } = useJournalName();
  const {
    entries,
    habitsByMonth,
    habitLog,
    sleepLog,
    moodLog,
    weightLog,
    weightUnit,
  } = useJournal();
  const [busy, setBusy] = useState(null);

  const payload = {
    journalName,
    entries,
    habitsByMonth,
    habitLog,
    sleepLog,
    moodLog,
    weightLog,
    weightUnit,
  };

  const run = (kind) => {
    setBusy(kind);
    try {
      const data = { ...payload };
      if (kind === "md") downloadJournalMarkdown(data);
      else downloadJournalJson(data);
    } finally {
      setTimeout(() => setBusy(null), 400);
    }
  };

  if (variant === "mobile") {
    return (
      <div className="m-settings-card">
        <h3 className="m-settings-heading">{t("exportData")}</h3>
        <p className="m-settings-export-desc">{t("exportDesc")}</p>
        <button type="button" className="m-settings-favs-btn" onClick={() => run("md")} disabled={!!busy}>
          <span className="material-symbols-outlined">draft</span>
          <span className="m-settings-favs-label">{busy === "md" ? t("exporting") : t("exportMarkdown")}</span>
        </button>
        <button type="button" className="m-settings-favs-btn" onClick={() => run("json")} disabled={!!busy}>
          <span className="material-symbols-outlined">data_object</span>
          <span className="m-settings-favs-label">{busy === "json" ? t("exporting") : t("exportJson")}</span>
        </button>
      </div>
    );
  }

  return (
    <>
      <button type="button" className="hamburger-item" onClick={() => run("md")} disabled={!!busy}>
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
          <polyline points="14 2 14 8 20 8" />
        </svg>
        {busy === "md" ? t("exporting") : t("exportMarkdown")}
      </button>
      <button type="button" className="hamburger-item" onClick={() => run("json")} disabled={!!busy}>
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
          <polyline points="7 10 12 15 17 10" />
          <line x1="12" y1="15" x2="12" y2="3" />
        </svg>
        {busy === "json" ? t("exporting") : t("exportJson")}
      </button>
    </>
  );
};

export default ExportJournalButtons;
